export const CUSTOM_FIELD_ASSIGN_MODULE_ID = 'custom-field-assign-module';

export const LOAD_CUSTOM_FIELD_ASSIGN_MODULE = () =>
  import('@capital-access/custom-fields/assign').then(m => m.CustomFieldsAssignModule);
